import tw from 'tailwind-styled-components'

// This placeholder is different from subtask placeholder inside the task
// b/c the latter requires MoveToBody to be displayed w/o cropping during scroll
export const TwSubtaskPlaceholder = tw.div`
  subtask-placeholder
  bg-action-default
  h-4
  rounded-2
  mt-2
  -mb-6
`
